import { RouteComponentProps } from 'react-router-dom'
import { IMatchParams } from 'shared/interfaces'
import {
  IApiToken,
  IClientAuth,
  IFeatures,
  ILocales,
  IUser,
  IUserProfile,
  ShortEntityResponse
} from 'reducers/Reducers.interfaces'
import { IPermissions } from 'core/selectors/Profile.selectors'
import { IActionCreatorAsync } from 'core/actions/Actions.interfaces'
import { LocalizeContextProps } from 'react-localize-redux'

export interface IUserDetailsStateProps {
  user?: IUser
  allPermissions: Record<string, ShortEntityResponse[]>
  localeList: ILocales
  profileId?: string
  profile?: IUser
  client_auth: IClientAuth[]
  tokens: IApiToken[]
  userProfile?: IUserProfile
  features: IFeatures
  permissions:IPermissions | null
}

export interface IUserDetailsOwnProps extends RouteComponentProps<IMatchParams> {
  permissions: IPermissions
}

interface IUserDetailsDispatchProps {
  fetchUserById: IActionCreatorAsync
  fetchPermissions: IActionCreatorAsync
  fetchClientAuthCerts: IActionCreatorAsync
  enableCertificateForUser: IActionCreatorAsync
  fetchApiTokens: IActionCreatorAsync
  editApiToken: IActionCreatorAsync
  deleteApiToken: IActionCreatorAsync
  fetchTenantById: IActionCreatorAsync
  deleteUser: IActionCreatorAsync
  resendVerificationLink: IActionCreatorAsync
  createStdUser: IActionCreatorAsync
  resendSsoEmail: IActionCreatorAsync
  sendSetupCacBasedLoginEmail: IActionCreatorAsync
  updateManagerPreference: IActionCreatorAsync
  fetchServicesByUserId: IActionCreatorAsync
  initLocalization: IActionCreatorAsync
  resetMfaLink: IActionCreatorAsync
}

export enum Sections {
  Overview = 'overview',
  Services = 'services',
  Credentials = 'access-credentials'
}

export type TUserDetailsProps = IUserDetailsStateProps & IUserDetailsOwnProps & IUserDetailsDispatchProps & LocalizeContextProps
